import { useState, useRef } from 'react';
import { api } from '../api';
import { styles } from '../styles';
import { BackIcon, PlusIcon, ImageIcon } from '../components/Icons';

function StatementIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <path d="M14 2v6h6" />
      <line x1="8" y1="13" x2="16" y2="13" />
      <line x1="8" y1="17" x2="13" y2="17" />
    </svg>
  );
}

export default function UploadScreen({ currentUser, onSuccess, onManualEntry, onImportStatement, onBack }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [preview, setPreview] = useState(null);
  const fileRef = useRef();
  const cameraRef = useRef();

  const handleFile = async (file) => {
    if (!file) return;
    
    setPreview(URL.createObjectURL(file));
    setUploading(true);
    setError(null);

    try {
      const data = await api.upload(`/receipts/upload?user_id=${currentUser}`, file);
      onSuccess(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setUploading(false);
      setPreview(null);
    }
  };

  return (
    <div style={styles.screen}>
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>
          <BackIcon />
        </button>
        <h1 style={styles.headerTitle}>Add Expense</h1>
        <div style={{ width: 20 }} />
      </header>
      
      <input
        ref={cameraRef}
        type="file"
        accept="image/*"
        capture="environment"
        onChange={(e) => handleFile(e.target.files[0])}
        style={{ display: 'none' }}
      />

      <input
        ref={fileRef}
        type="file"
        accept="image/*,application/pdf"
        onChange={(e) => handleFile(e.target.files[0])}
        style={{ display: 'none' }}
      />

      {preview ? (
        <div style={styles.previewContainer}>
          <img src={preview} alt="Preview" style={styles.preview} />
          {uploading && (
            <div style={styles.uploadingOverlay}>
              <div style={styles.spinner} />
              <span>Processing receipt...</span>
            </div>
          )}
        </div>
      ) : (
        <div style={styles.addOptions}>
          <button 
            style={styles.optionCard} 
            onClick={() => fileRef.current?.click()} 
            disabled={uploading}
          >
            <div style={styles.optionIcon}>
              <ImageIcon />
            </div>
            <span style={styles.optionTitle}>Scan Receipt</span>
            <span style={styles.optionDesc}>Take a photo or upload image</span>
          </button>
          
          <button style={styles.optionCard} onClick={onManualEntry}>
            <div style={styles.optionIcon}>
              <PlusIcon size={32} />
            </div>
            <span style={styles.optionTitle}>Manual Entry</span>
            <span style={styles.optionDesc}>Enter details yourself</span>
          </button>

          <button style={styles.optionCard} onClick={onImportStatement}>
            <div style={styles.optionIcon}>
              <StatementIcon />
            </div>
            <span style={styles.optionTitle}>Import Statement</span>
            <span style={styles.optionDesc}>Scan a CC statement screenshot</span>
          </button>
        </div>
      )}

      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
}